import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid"; // Correct import
import { Paper } from "@mui/material";
import TopBar from "./TopBar";
import ResumesList from "./ResumesList";
import ResumePdfViewer from "./ResumePdfViewer";
import ResumeProfile from "./ResumeDetails";
import { selectedResume, selectedTabViewAction } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { myCandidatesSelector } from "../redux/selector";
import axios from "axios";
import key from "../../../../src/clientVariables.json";

var openAISkills = require("../../common/OpenAIComponent");

const ResumeSelectionView = () => {
  const dispatch = useDispatch();
  const { jobDetails, candidateDetails } = useSelector(myCandidatesSelector);
  const [jobSkillsAI, setJobSkillsAI] = useState(null);
  const [resume, setResume] = useState();
  const [candidateResumesList, setCandidateResumesList] = useState([]);

  const selectedResumeForSubmission = (item) => {
    //console.log(item);
    setResume(item);
  };

  useEffect(() => {
    let isMounted = true;

    const fetchResumes = async () => {
      try {
        if (candidateDetails?.candidate_id) {
          const response = await axios.post(
            `${key.domain}/common/get_candidate_resumes_list`,
            {
              candidate_id: candidateDetails.candidate_id,
              user_id: candidateDetails.r_id?.split(',')[1] || "479158",
            }
          );

            
          if (response?.data?.success === 1 && isMounted) {
            setCandidateResumesList(response?.data?.data || []);
            const primaryResume = response?.data?.data?.find(
              (resume) => resume.isPrimary === 1
            );
            const selectedFile = primaryResume || response?.data?.data?.[0];
            if (selectedFile) {
              setResume(selectedFile);
              selectedResumeForSubmission(selectedFile);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching resumes:', error);
      }
    };

    if (!resume) {
      fetchResumes();
    }

    return () => {
      isMounted = false;
    };
  }, [candidateDetails]);
  useEffect(() => {
    if (jobDetails && jobDetails?.job_description) {
      const descr = jobDetails?.job_description;
      getJobSkillsFromAI(descr);
    }
  }, []);

  const getJobSkillsFromAI = (desc) => {
    var msg =
      "This is job description, it has job_role, skills and other details can you extract me {job_role (excluding any additional details or qualifications), skills (in shortforms as list)} only, no other information and make it as json  " +
      desc;

    openAISkills.openAI(msg, (error, results) => {
      if (error) {
        console.log(error);
      } else {
        var data = results;

        var skillss = data && data?.skills ? data?.skills : [];

        if (Array.isArray(skillss)) {
          var skills =
            skillss?.length > 0 ? skillss?.map((s) => s).join(", ") : "";
        } else {
          const skillString = skillss?.split(",");
          var skills =
            skillString?.length > 0
              ? skillString?.map((s) => s).join(", ")
              : "";
        }
        setJobSkillsAI(skills);
      }
    });
  };

  const onSubmit = () => {
    dispatch(selectedResume(resume));
    dispatch(selectedTabViewAction("Submission"));
  };

  const paperStyles = {
    borderRadius: "8px",
    height: "100vh",
    overflow: "auto"
  };
  return (
    <div>
      <TopBar onSubmit={onSubmit} resume={resume} />
      <Grid container spacing={1}>
        <Grid item sm={3.2}>
          <Paper elevation={2} sx={paperStyles}>
            <ResumesList selectedResume={selectedResumeForSubmission} candidateResumesList={candidateResumesList} />
          </Paper>
        </Grid>
        <Grid item sm={4.8}>
          <Paper
            elevation={2}
            sx={paperStyles}
          >
            <ResumePdfViewer resume={resume} />
          </Paper>
        </Grid>
        <Grid item sm={4}>
          <ResumeProfile
            resume={resume}
            requiredSkills={jobSkillsAI ? jobSkillsAI.split(",") : []}
            activeJobSkills={jobSkillsAI ? jobSkillsAI.split(",") : []}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ResumeSelectionView;
